<template>
  <transition
    v-on:after-enter="hide(5000)"
    mode="in-out"
    enter-active-class="fadeInDown"
    leave-active-class="fadeOutUp"
    appear>
    <div v-if="show" class="animated message-box">
      <article class="message is-warning">
        <div class="message-header">
          <p>{{ this.$store.state.error.name }}!</p>
          <button v-on:click="hide(0)" class="delete" aria-label="delete"></button>
        </div>
        <div class="message-body">
          {{ this.$store.state.error.response ? this.$store.state.error.response.data.error.message : this.$store.state.error.message }}
        </div>
      </article>
    </div>
  </transition>
</template>

<script>
  export default {
    computed: {
      show () {
        return this.$store.state.showErrorBubble
      }
    },

    methods: {
      hide (delay) {
        setTimeout(() => {
          if (this.show) {
            this.$store.commit('SHOW_ERROR_BUBBLE', false)
          }
        }, delay)
      }
    }
  }
</script>

<style lang="scss">
  @import '~bulma/sass/utilities/variables';
  @import '~bulma/sass/utilities/mixins';

  .message-box {
    position: fixed;
    top: 2px;
    left: 50%;
    z-index: 1024 + 233;
  }

  .message {
    position: relative;
    right: 50%;
    min-width: 300px;
  }
</style>



// WEBPACK FOOTER //
// ErrorBubble.vue?f9896fa0